/**
 * @file Identifiants logiques des étapes du parcours de réservation.
 * @module packages.common.components.table-reservation.constants.steps
 *
 * Constantes extraites hors du hook `useReservationSteps` pour pouvoir être
 * importées par des utilitaires de bas niveau (ex. `stepSummary`) sans
 * créer de dépendance circulaire avec le hook (qui lui-même importe ces
 * utilitaires). Le hook réexporte `BASE_STEPS` pour préserver les imports
 * existants des consommateurs.
 *
 * Les valeurs sont des strings nominatives pour rendre le mapping robuste :
 * les consommateurs (breadcrumb, handlers, renderer de contenu) indexent par
 * identifiant logique, jamais par position. Toute modification ultérieure
 * de l'ordre du parcours est absorbée sans impacter les correspondances
 * clé → composant / icône / libellé.
 */

export const BASE_STEPS = Object.freeze({
  SERVICE_GUESTS: 'SERVICE_GUESTS',
  DATE: 'DATE',
  ROOM: 'ROOM',
  TIME: 'TIME',
  FORMULA: 'FORMULA',
  CONTACT: 'CONTACT',
  DETAILS: 'DETAILS',
  PAYMENT: 'PAYMENT',
  CONFIRMATION: 'CONFIRMATION',
});
